import { request } from './R2FService'

// 获取验证码
export const getVerificationCode = (data) =>
  request(`/open/getVerificationCode`, 'POST', data)

// 登录
export const login = (data) =>
  request(`/open/login`, 'POST', data)

// 获取消息
export const getOpenRestData = (data) =>
  request(`/send/sms/querySendSmsRecord`, 'POST', data)

// 发送消息
export const replySms = (data) =>
  request(`/send/sms/replySms`, 'POST', data)


export const getTokenByValidCode = (data) =>
  request(`/open/getTokenByValidCode`, 'POST', data)

export const querySmsLinkRecordByCode = (data) =>
  request(`/send/sms/querySmsLinkRecordByCode`, 'POST', data)

export const replySmsLinkByCode = (data) =>
  request(`/send/sms/replySmsLinkByCode`, 'POST', data)

export const checkRandomPath = (data) =>
    request(`/open/validRandomPath`, 'POST', data)

export const queryReplyInterval = ()=>
    request(`send/sms/queryReplyInterval`, 'POST')
